var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isUserLoggedIn)?_c('div',{staticClass:"login-modal"},[_c('h3',[_vm._v("You should login to join chat!")]),_c('router-link',{attrs:{"to":"/auth/login"}},[_c('button',[_vm._v("Login Now!")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }